let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kz11B")).then(() => parcelRequire('8IIKL'));